import { BaseApiService } from '@/shared/api/services/base.service';
import type { ProjectAnglesGuide } from '@/types/project';

interface AnglesGuideResponse {
  data: {
    type: string;
    id: string;
    attributes: ProjectAnglesGuide;
  };
}

/**
 * Localized copy for the "Tips for great source angles" help block on the Angles
 * overview screen. Single source of truth lives on the API
 * (GET /v1/content/project-angles-guide); the client renders it as-is. Locale is
 * negotiated via the Accept-Language header the api client attaches automatically.
 */
class AnglesGuideService extends BaseApiService {
  async get(): Promise<ProjectAnglesGuide> {
    const response = await this.httpGet<AnglesGuideResponse>(
      '/v1/content/project-angles-guide'
    );
    return response.data.attributes;
  }
}

export const anglesGuideService = new AnglesGuideService();
